import { Glyph } from "../../types";

const SvgExcelExport: Glyph = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="4" y="5" width="16" height="14" rx="2"></rect>
      <path d="M4 9.5h16"></path>
      <path d="M9 13l6 4 M15 13l-6 4"></path>
    </svg>
  );
};

export default SvgExcelExport;
